
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import WhatsAppButton from '../../../components/feature/WhatsAppButton';
import EcoPilot from '../../../components/feature/EcoPilot';
import { useState } from 'react';
import Button from '../../../components/base/Button';
import Card from '../../../components/base/Card';
import QuoteModal from '../../../components/feature/QuoteModal';

export default function CSRDPage() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  return (
    <>
      <Header />
      <main className="min-h-screen">
        {/* Hero Section */}
        <section 
          className="relative py-32 bg-cover bg-center"
          style={{ 
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=European%20Union%20CSRD%20Corporate%20Sustainability%20Reporting%20Directive%20compliance%20with%20EU%20business%20professionals%20in%20modern%20office%20environment%2C%20European%20flags%20and%20digital%20reporting%20systems&width=1200&height=600&seq=605&orientation=landscape)' 
          }}
        >
          <div className="absolute inset-0 bg-indigo-900/80"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl">
              <h1 className="text-5xl font-bold text-white mb-6 animate-in fade-in slide-in-from-bottom-8 duration-1000">
                CSRD Sürdürülebilirlik Raporu
              </h1>
              <p className="text-xl text-indigo-100 mb-8 leading-relaxed animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300">
                AB'nin Corporate Sustainability Reporting Directive gerekliliklerine uyum sağlayın. Avrupa pazarında güvenilir bir partner olarak konumlanın.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-500">
                <Button 
                  size="lg"
                  onClick={() => setIsQuoteModalOpen(true)}
                  className="whitespace-nowrap"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-file-text-line"></i>
                  </div>
                  Teklif Al
                </Button>
                <Button 
                  size="lg" 
                  variant="outline"
                  onClick={() => window.open('https://calendly.com/ecoventra', '_blank')}
                  className="border-white text-white hover:bg-white hover:text-indigo-700 whitespace-nowrap"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-calendar-line"></i>
                  </div>
                  Ücretsiz Konsültasyon
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Key Features */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                CSRD Raporlama Hizmetlerimiz
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Avrupa Birliği CSRD direktifine tam uyum için kapsamlı çözümler
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  icon: 'ri-europe-line',
                  title: 'CSRD Direktifi',
                  description: 'AB CSRD gerekliliklerine tam uyumluluk'
                },
                {
                  icon: 'ri-file-list-3-line',
                  title: 'ESRS Standartları',
                  description: 'European Sustainability Reporting Standards uygulaması'
                },
                {
                  icon: 'ri-computer-line',
                  title: 'Dijital Raporlama',
                  description: 'XBRL formatında dijital raporlama hazırlığı'
                },
                {
                  icon: 'ri-shield-star-line',
                  title: 'AB Uyumluluk',
                  description: 'Avrupa pazarı için yasal uyumluluk garantisi'
                }
              ].map((feature, index) => (
                <Card key={index} className="p-6 text-center hover:shadow-lg transition-shadow duration-300">
                  <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${feature.icon} text-2xl text-indigo-600`}></i>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
                  <p className="text-gray-600 text-sm">{feature.description}</p>
                </Card>
              ))}
            </div>
          </div>
        </section>

        {/* Process */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                CSRD Raporlama Sürecimiz
              </h2>
              <p className="text-xl text-gray-600">
                14-18 haftalık AB standartlarında raporlama
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  step: '1',
                  title: 'CSRD Gap Analizi',
                  description: 'Mevcut durum vs CSRD gereksinimleri analizi',
                  duration: '2-3 hafta'
                },
                {
                  step: '2',
                  title: 'ESRS Materiality',
                  description: 'Çift önemlilik analizinde ESRS uygulaması',
                  duration: '3-4 hafta'
                },
                {
                  step: '3',
                  title: 'ESRS Veri Toplama',
                  description: 'ESRS E, S, G konularında veri derleme',
                  duration: '5-7 hafta'
                },
                {
                  step: '4',
                  title: 'Dijital Rapor Hazırlama',
                  description: 'XBRL formatında CSRD raporu hazırlama',
                  duration: '4-4 hafta'
                }
              ].map((process, index) => (
                <div key={index} className="relative">
                  <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-indigo-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4">
                        {process.step}
                      </div>
                      <div className="text-sm text-indigo-600 font-medium">{process.duration}</div>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{process.title}</h3>
                    <p className="text-gray-600 text-sm">{process.description}</p>
                  </div>
                  {index < 3 && (
                    <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                      <i className="ri-arrow-right-line text-2xl text-indigo-300"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6">
                  CSRD Raporlamasının Faydaları
                </h2>
                <div className="space-y-6">
                  {[
                    {
                      icon: 'ri-europe-line',
                      title: 'AB Pazarı Erişimi',
                      description: 'Avrupa pazarında sürdürülebilir iş ortağı olarak tanınma'
                    },
                    {
                      icon: 'ri-award-line',
                      title: 'Avrupa Kredibilitesi',
                      description: 'AB standartlarında güvenilirlik ve itibar'
                    },
                    {
                      icon: 'ri-smartphone-line',
                      title: 'Dijital Raporlama Avantajı',
                      description: 'XBRL formatında modern ve erişilebilir raporlama'
                    },
                    {
                      icon: 'ri-scales-line',
                      title: 'Düzenleyici Uyum',
                      description: 'AB yasal gereksinimlerine proaktif uyum'
                    }
                  ].map((benefit, index) => (
                    <div key={index} className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`${benefit.icon} text-xl text-indigo-600`}></i>
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-1">{benefit.title}</h3>
                        <p className="text-gray-600">{benefit.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=European%20business%20professionals%20celebrating%20CSRD%20compliance%20success%20with%20EU%20digital%20reporting%20systems%20and%20sustainability%20achievements%20in%20modern%20corporate%20environment&width=600&height=400&seq=606&orientation=landscape"
                  alt="CSRD Raporlama Faydaları"
                  className="rounded-2xl shadow-2xl"
                />
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-indigo-600">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              CSRD Sürdürülebilirlik Raporunuz İçin Başlayın
            </h2>
            <p className="text-xl text-indigo-100 mb-10">
              AB pazarında rekabet avantajı için uzman desteği alın
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                size="lg"
                onClick={() => setIsQuoteModalOpen(true)}
                className="bg-white text-indigo-600 hover:bg-gray-100 whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-file-text-line"></i>
                </div>
                Detaylı Teklif Al
              </Button>
              <Button 
                size="lg" 
                variant="outline"
                onClick={() => window.open('https://api.whatsapp.com/send?phone=905326230183&text=Merhaba, CSRD sürdürülebilirlik raporu hakkında bilgi almak istiyorum.', '_blank')}
                className="border-white text-white hover:bg-white hover:text-indigo-600 whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-whatsapp-line"></i>
                </div>
                WhatsApp ile İletişim
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
      <EcoPilot />
      
      <QuoteModal 
        isOpen={isQuoteModalOpen} 
        onClose={() => setIsQuoteModalOpen(false)} 
      />
    </>
  );
}
